import Vue from "vue";
import api from "@/services/api";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions";
import { arrayToObj, exists } from "@/lib/utilities";

function initialState() {
  return {
    allPermissions: [],
    categories: [],
    editingPermission: {},
    editingCategory: {},
    showEditPermissionModal: false,
    showManageCategoriesModal: false,
    showEditCategoriesModal: false
  };
}

const actions = {
  async getPermissionsToManage(context) {
    const data = await api.fetchAllPermissions();
    context.commit("setPermissionsToManage", data);
    return data;
  },
  getAllPermissionCategories(context) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/rolepermissions/getallpermissioncategories")
        .then(function(data) {
          if (data && data.data && data.data.Data)
            context.commit("setCategories", data.data.Data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPermissionsUserNames(context, rows) {
    let promises = [];

    for (let i = 0; i < rows.length; i++) {
      promises.push(
        new Promise((resolve, reject) => {
          if (rows[i].UpdateUser) {
            Vue.http
              .get("/users/" + rows[i].UpdateUser)
              .then(function(data) {
                if (
                  data &&
                  data.data &&
                  data.data.Data &&
                  data.data.Data.Name
                ) {
                  rows[i].UserName = data.data.Data.Name;
                } else rows[i].UserName = rows[i].UpdateUser;
                resolve(rows[i]);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            rows[i].UserName = " ";
            resolve(rows[i]);
          }
        })
      );
    }
    return Promise.all(promises);
  },
  savePermission(context, data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/rolepermissions/savepermission", data)
        .then(function(data) {
          context.commit("handleSavePermissionResponse", data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deletePermission(context, id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete("/rolepermissions/deletepermission?permissionId=" + id)
        .then(function(data) {
          context.commit("handleDeletePermissionResponse", {
            PermissionId: id,
            Response: data
          });
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  savePermissionCategory(context, data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/rolepermissions/savepermissioncategory", data)
        .then(function(result) {
          context.commit("handleSavePermissionCategoryResponse", result);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPermissionUserCounts(context, permissionId) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/RolePermissions/GetUserCountForPermission?permissionIds="+permissionId)
        .then(function(result) {
          if (result && result.data) resolve(result.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchUsersWithPermission: function(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/RolePermissions/GetUserPermissions", request)
        .then(function(response) {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removePermissionFromUser: function(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete("/RolePermissions/permissions", {data : request})
        .then(function(response) {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  setPermissionsToManage(state, data) {
    state.allPermissions = data || [];
  },
  handleSavePermissionResponse(state, data) {
    if (data && data.data && data.data.Success && data.data.Data) {
      let permission = data.data.Data;
      let index =
        state.allPermissions && state.allPermissions.length > 0
          ? state.allPermissions.findIndex(item => item.Id == permission.Id)
          : -1;
      if (index > -1) state.allPermissions.splice(index, 1, permission);
      else state.allPermissions.push(permission);
    }
  },
  handleDeletePermissionResponse(state, data) {
    // Remove the deleted permission from store
    let permissionId = data.PermissionId;
    let response = data.Response;

    if (
      response &&
      response.data &&
      response.data.Success &&
      state.allPermissions &&
      state.allPermissions.length > 0
    ) {
      let index = state.allPermissions.findIndex(
        item => item.Id == permissionId
      );
      if (index > -1) state.allPermissions.splice(index, 1);
    }
  },
  toggleEditPermissionModal(state, data) {
    state.showEditPermissionModal = data;
  },
  setEditingPermission(state, data) {
    state.editingPermission = data;
  },
  setEditingCategory(state, data) {
    state.editingCategory = data;
  },
  toggleManageCategoriesModal(state, data) {
    state.showManageCategoriesModal = data;
  },
  toggleEditCategoryModal(state, data) {
    state.showEditCategoriesModal = data;
  },
  setCategories(state, data) {
    state.categories = data
      ? data.sort(HelperFunctions.sortByProperty("name"))
      : null;
  },
  handleSavePermissionCategoryResponse(state, data) {
    if (data && data.data && data.data.Success && data.data.Data) {
      let category = data.data.Data;
      let index =
        state.categories && state.categories.length > 0
          ? state.categories.findIndex(item => item.Id == category.Id)
          : -1;
      if (index > -1) state.categories.splice(index, 1, category);
      else state.categories.push(category);
    }
  }
};

const getters = {
  allPermissions(state) {
    return state.allPermissions || [];
  },
  permissionMap(state) {
    return arrayToObj(state.allPermissions, "Id");
  },
  categories(state) {
    return state.categories;
  },
  showEditPermissionModal(state) {
    return state.showEditPermissionModal;
  },
  editingPermission(state) {
    return state.editingPermission;
  },
  editingCategory(state) {
    return state.editingCategory;
  },
  showManageCategoriesModal(state) {
    return state.showManageCategoriesModal;
  },
  showEditCategoriesModal(state) {
    return state.showEditCategoriesModal;
  }
};

export default {
  state: initialState(),
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Permissions.js